module.exports = __webpack_public_path__ + "img/54d3d61c127e01114e7d317296babff1.1dfa11ae.png";